// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__yca-e","wrapper":"Logo_wrapper__gLXXf","logoOriginal":"Logo_logoOriginal__9-0Y+","logoPulse":"Logo_logoPulse__NezEt","pulse2":"Logo_pulse2__y87Th"};